<div class="cpcontent">
    <h2 style="display:inline-block;margin-left:50px">Establish a polygon on a Map</h2>

    <button class="btn btn-primary" (click)="initMap()" style="margin-left:50px">Init Map</button>
    <div class="row">
        <div class="col-md-8">
            <div #pagemap style="width:100%;height:400px"></div>
        </div>
        <div class="col-md-4">

            <div *ngIf="showMenu">
                <h5>Create a polygon</h5>
                <button class="btn btn-primary" (click)="clear()">Clear</button>
                <sa-select [(Id)]="actionid" [title]="'Action'" [options]="actions" style="display:inline-block;margin-left:20px"></sa-select>
                <button class="btn btn-primary" (click)="createPolygon()" style="margin-left:10px">Create Polygon</button>
                <br>
                Instructions:
                <ul>
                    <li>Select action</li>
                    <li>Click on map to define points of a polygon</li>
                    <li>Once finished, click "create polygon"</li>
                    <li>Now click anywhere on the map to verify whether it is inside or outside</li>
                </ul>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Lat</th>
                            <th>Lng</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let point of polygon">
                            <td>{{point.lat}}</td>
                            <td>{{point.lng}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>